var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInkPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_723_6005",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 151
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 150,
    height: 150,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_723_6005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.4688 78.7188L72.0313 55.125L89.375 37.9375L84.8437 33.4063L55 63.25C53.75 64.5 52.2917 65.125 50.625 65.125C48.9583 65.125 47.5 64.5 46.25 63.25C45 62 44.375 60.5156 44.375 58.7969C44.375 57.0781 45 55.5938 46.25 54.3438L75.9375 24.6562C78.4375 22.1562 81.3802 20.9063 84.7656 20.9063C88.151 20.9063 91.0938 22.1562 93.5938 24.6562L98.125 29.1875L105.937 21.375C107.187 20.125 108.672 19.5 110.391 19.5C112.109 19.5 113.594 20.125 114.844 21.375L129.375 35.9062C130.625 37.1563 131.25 38.6406 131.25 40.3594C131.25 42.0781 130.625 43.5625 129.375 44.8125L95.4688 78.7188ZM25 132C23.2292 132 21.7448 131.401 20.5469 130.203C19.349 129.005 18.75 127.521 18.75 125.75V113.719C18.75 112.052 19.0625 110.464 19.6875 108.953C20.3125 107.443 21.1979 106.115 22.3437 104.969L63.125 64.0312L86.7188 87.4688L45.7813 128.406C44.6354 129.552 43.3073 130.438 41.7969 131.063C40.2865 131.688 38.6979 132 37.0312 132H25Z",
    fill: "#CDBCAD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkPen);
export default __webpack_public_path__ + "static/media/ink_pen.beb6cb301ab007800753a8793b5afe07.svg";
export { ForwardRef as ReactComponent };